import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { LessorRepresentativeDto, LessorInfoDto, LessorRepTypeDto, AddressBookDto, BankDto, LandTitleDto } from '@cradua/data';
import { SearchModalComponent } from 'libs/acquisition/src/lib/components/search-modal/search-modal.component';
import Swal from 'sweetalert2';
import { LessorRepresentativeTableComponent } from './lessor-representative-table/lessor-representative-table.component';

@Component({
  selector: 'cradua-lessor-representative',
  templateUrl: './lessor-representative.component.html',
  styleUrls: ['./lessor-representative.component.scss']
})
export class LessorRepresentativeComponent implements OnInit {

  @Input() selectedLessorInfo: LessorInfoDto;
  @Input() lessorRepTypes: LessorRepTypeDto[];
  @Input() banks: BankDto[];
  @Input() addressBook: AddressBookDto[];
  @Input() isLoadingLessorRepresentative: boolean;
  @Input() lessorRepresentatives: LessorRepresentativeDto[];
  @Output() emitLessorRepresentative = new EventEmitter<any>();
  @Output() emitLessorRepresentativeDelete = new EventEmitter<any>();
  @Output() emitTask = new EventEmitter<any>();
  @ViewChild(LessorRepresentativeTableComponent) child: LessorRepresentativeTableComponent;
  lessorRepresentativeForm: FormGroup;
  selectedIndex = null;
  selectedAddressBook: AddressBookDto;

  constructor(
    private fb: FormBuilder,
    public dialog: MatDialog,
    ) { }

  ngOnInit(): void {
    this.createSurveyForm();
  }

  createSurveyForm() {
    this.lessorRepresentativeForm = this.fb.group({
      PhoneNo: [{value: null, disabled: true}],
      Name: [{value: null, disabled: false}],
      Address: [{value: null, disabled: true}],
      AccountNo: [{value: null, disabled: true}],
      BankId: [{value: null, disabled: true}],
      LessorRepTypeId: null,
      FromDate: null,
      ToDate: null,
      AddressBookId: null,
      LandTitleId: null,
    });
  }

  onEdit(value: any) {
    this.selectedIndex = value['index'];
    this.lessorRepresentativeForm.patchValue({
      PhoneNo: value.PhoneNo,
      Name: value.Name,
      Address: value.Address,
      AccountNo: value.AccountNo,
      BankId: value.BankId,
      LessorRepTypeId: value.LessorRepTypeId,
      FromDate: value.FromDate != null ? this.formatDate(value.FromDate) : null,
      ToDate: value.ToDate != null ? this.formatDate(value.ToDate) : null,
      AddressBookId: value.AddressBookId,
      LandTitleId: value.LandTitleId,
      LessorsId: this.selectedLessorInfo.id,
    });
  }

  addNew(formValue: any) {
    if(this.lessorRepresentativeForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.child.lessorRepresentativeFormArray['controls'][this.selectedIndex].patchValue(formValue);
    } else {
      this.child.addLessorRepresentative({
        PhoneNo: formValue.PhoneNo,
        Name: formValue.Name,
        Address: formValue.Address,
        AccountNo: formValue.AccountNo,
        BankId: formValue.BankId,
        LessorRepTypeId: formValue.LessorRepTypeId,
        FromDate: formValue.FromDate,
        ToDate: formValue.ToDate,
        AddressBookId: formValue.AddressBookId,
        LandTitleId: formValue.LandTitleId,
        LessorsId: this.selectedLessorInfo.id,
      });
    }
    this.selectedIndex = null;
    this.lessorRepresentativeForm.reset()
  }

  onSubmit(){
    this.emitLessorRepresentative.emit(this.child.lessorRepresentativeArrayForm.value['LessorRepresentative']);
    if(this.child.filteredDelete.length > 0) {
      this.emitLessorRepresentativeDelete.emit(this.child.filteredDelete);
    }

  }

  onReset() {
    this.lessorRepresentativeForm.reset();
    this.selectedIndex = null;
  }

  onBack() {
    this.emitTask.emit('list');
  }


  onSearchDialog() {

    const dialogConfig = new MatDialogConfig();

    // dialogConfig.disableClose = false;
    dialogConfig.id = "modal-component";
    dialogConfig.height = "90%";
    dialogConfig.width = "100%";
    // dialogConfig.minHeight = '100vh';
    // dialogConfig.minWidth = '100%'
    // dialogConfig.panelClass = "custom-dialog-container";
    // dialogConfig.backdropClass = "backdropBackground";


    const dialogRef = this.dialog.open(
      SearchModalComponent,
      dialogConfig,
    );

    dialogRef.afterClosed().subscribe((result: AddressBookDto) => {
      this.selectedAddressBook = result;
      if(result !== undefined) {
        this.lessorRepresentativeForm.patchValue({
          PhoneNo:  result.PhoneNo,
          Name:  result.Name,
          Address: result.Address,
          AccountNo: result.AccountNo,
          BankId: result.BankId,
          AddressBookId: result.id,
        });
      }

    });
  }


  formatDate(date) {
    // tslint:disable-next-line: one-variable-per-declaration
    let d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) {
      month = '0' + month;
    }
    if (day.length < 2) {
      day = '0' + day;
    }

    return [year, month, day].join('-');
  }

}
